var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMySchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My_schedule") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.873,3.105 L36.873,5.27 L28.198,5.27 L28.198,3.105 C28.198,1.91 27.226,0.942 26.028,0.942 L26.028,0.942 C24.831,0.942 23.859,1.91 23.859,3.105 L23.859,3.105 L23.859,5.27 L15.183,5.27 L15.183,3.105 C15.183,1.91 14.213,0.942 13.014,0.942 L13.014,0.942 C11.816,0.942 10.845,1.91 10.845,3.105 L10.845,3.105 L10.845,5.27 L8.677,5.27 C3.884,5.27 0.001,9.145 0.001,13.925 L0.001,13.925 L0.001,44.219 C0.001,48.958 3.817,52.808 8.553,52.875 L8.553,52.875 L43.505,52.875 C48.198,52.809 51.99,49.024 52.056,44.343 L52.056,44.343 L52.056,13.802 C51.99,9.078 48.131,5.27 43.381,5.27 L43.381,5.27 L41.211,5.27 L41.211,3.105 C41.211,1.91 40.24,0.942 39.043,0.942 L39.043,0.942 C37.845,0.942 36.873,1.91 36.873,3.105 L36.873,3.105 Z M41.211,11.761 L41.211,9.596 L43.381,9.596 C45.777,9.596 47.719,11.535 47.719,13.925 L47.719,13.925 L47.719,18.253 L4.338,18.253 L4.338,13.925 C4.338,11.535 6.28,9.596 8.677,9.596 L8.677,9.596 L10.845,9.596 L10.845,11.761 C10.845,12.956 11.816,13.925 13.014,13.925 L13.014,13.925 C14.213,13.925 15.183,12.956 15.183,11.761 L15.183,11.761 L15.183,9.596 L23.859,9.596 L23.859,11.761 C23.859,12.956 24.831,13.925 26.028,13.925 L26.028,13.925 C27.226,13.925 28.198,12.956 28.198,11.761 L28.198,11.761 L28.198,9.596 L36.873,9.596 L36.873,11.761 C36.873,12.956 37.845,13.925 39.043,13.925 L39.043,13.925 C40.24,13.925 41.211,12.956 41.211,11.761 L41.211,11.761 Z M4.338,44.219 L4.338,22.58 L47.719,22.58 L47.719,44.219 C47.719,46.61 45.777,48.547 43.381,48.547 L43.381,48.547 L8.677,48.547 C6.28,48.547 4.338,46.61 4.338,44.219 L4.338,44.219 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.104 0.895,5 2,5 L2,5 C3.105,5 4,4.104 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.105 0.895,5 2,5 L2,5 C3.105,5 4,4.105 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.104 0.895,5 2,5 L2,5 C3.105,5 4,4.104 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.105 0.895,5 2,5 L2,5 C3.105,5 4,4.105 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.104 0.895,5 2,5 L2,5 C3.105,5 4,4.104 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.105 0.895,5 2,5 L2,5 C3.105,5 4,4.105 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.104 0.895,5 2,5 L2,5 C3.105,5 4,4.104 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.999 C0,4.105 0.895,5 2,5 L2,5 C3.105,5 4,4.105 4,2.999 L4,2.999 C4,1.895 3.105,0.999 2,0.999 L2,0.999 C0.895,0.999 0,1.895 0,2.999 L0,2.999 Z",
    id: "path-17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_schedule",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-4.999 57.876 57.057 57.876 57.057 -4.058 -4.999 -4.058"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(11.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FCBC00",
    mask: "url(#mask-4)",
    points: "-5 10 9 10 9 -4 -5 -4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(11.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FCBC00",
    mask: "url(#mask-6)",
    points: "-5 10 9 10 9 -4 -5 -4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(20.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FCBC00",
    mask: "url(#mask-8)",
    points: "-5 10 9 10 9 -4 -5 -4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(20.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FCBC00",
    mask: "url(#mask-10)",
    points: "-5 10 9 10 9 -4 -5 -4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(28.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FCBC00",
    mask: "url(#mask-12)",
    points: "-5 10 9 10 9 -4 -5 -4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(28.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#FCBC00",
    mask: "url(#mask-14)",
    points: "-5 10 9 10 9 -4 -5 -4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(37.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#FCBC00",
    mask: "url(#mask-16)",
    points: "-5 10 9 10 9 -4 -5 -4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(37.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#FCBC00",
    mask: "url(#mask-18)",
    points: "-5 10 9 10 9 -4 -5 -4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySchedule);
export default __webpack_public_path__ + "static/media/my-schedule.91e5ce816f971405a5eee88edc2c093d.svg";
export { ForwardRef as ReactComponent };